<!-- <mat-toolbar color="primary" class="example-toolbar">
	<button mat-icon-button (click)="isExpanded = !isExpanded"><mat-icon>menu</mat-icon></button>
	<h1 class="example-app-name">Squickr</h1>
</mat-toolbar>
<mat-sidenav-container class="example-container" autosize>
	<mat-sidenav #sidenav class="example-sidenav" mode="side" opened="true" (mouseenter)="mouseenter()" (mouseleave)="mouseleave()">
		<mat-nav-list>
			<mat-list-item (click)="showSubmenu = !showSubmenu" class="parent" routerLink="/">
				<span class="full-width" *ngIf="isExpanded || isShowing">Home</span>
				<mat-icon mat-list-icon>home</mat-icon> -->
				<!-- <mat-icon class="menu-button" [ngClass]="{'rotated' : showSubmenu}" *ngIf="isExpanded || isShowing">expand_more</mat-icon> -->
			<!-- </mat-list-item>
      <mat-list-item routerLink="/logout">
				<span class="full-width" *ngIf="isExpanded || isShowing">Logout</span>
				<mat-icon mat-list-icon>logout</mat-icon>
      </mat-list-item> -->
      <!-- /////////////////////////////////// -->
			<!-- <div class="submenu" [ngClass]="{'expanded' : showSubmenu}" *ngIf="isShowing || isExpanded">
				<a mat-list-item href="...">Submenu Item 1</a>
				<a mat-list-item href="...">Submenu Item 2</a>
				<mat-list-item (click)="showSubSubMenu = !showSubSubMenu" class="parent">
					<span class="full-width" *ngIf="isExpanded || isShowing">Nested Menu</span>
					<mat-icon class="menu-button" [ngClass]="{'rotated' : showSubSubMenu}" *ngIf="isExpanded || isShowing">expand_more</mat-icon>
				</mat-list-item>
				<div class="submenu" [ngClass]="{'expanded' : showSubSubMenu}" *ngIf="isShowing || isExpanded">
					<mat-list-item>SubSubmenu Item 1</mat-list-item>
					<mat-list-item>SubSubmenu Item 2</mat-list-item>
				</div>
			</div> -->
      <!-- //////////////////////////////////////// -->
		<!-- </mat-nav-list>
    <mat-nav-list>
</mat-nav-list>
	</mat-sidenav>

  	<div class="example-sidenav-content">
		<router-outlet></router-outlet>
	</div>

</mat-sidenav-container> -->

<app-main-nav></app-main-nav>

<!-- Copyright 2017 Google Inc. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license -->
